module.exports = __webpack_public_path__ + "static/planet3.e1dafec2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Hero/planets/planet3.svg
// module id = 697
// module chunks = 213534597649335